import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Grid,
  Paper,
  Toolbar,
  makeStyles,
  Typography,
  TextField,
  Button,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import '../styles.scss';
//Components
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenDialogBox from '../../../global_components/KenDialogBox';
import KenSelect from '../../../global_components/KenSelect';
import KenCheckbox from '../../../global_components/KenCheckbox/index';
import KenButton from '../../../global_components/KenButton';
import KenInputField from '../../../global_components/KenInputField';
import KenAutoComplete from '../../../global_components/KenAutoComplete/index';
import KenGridEditable from '../../../global_components/kenEditDataGrid/kenGridEditable';
import KenDialog from '../../../global_components/KenDialogBox';
import KenLoader from '../../../Components/KenLoader/index';
import KenSnackbar from '../../../Components/KenSnackbar/index';
// JSON
import { FacultyEnrollmentData } from './data.json';
import {
  getDataForCourseEnrolment,
  getFacultyList,
  getCourseVersionData,
  postFacultyEnrollment,
} from '../../../Utils/apiServices';
// ICO
import { BsSearch } from 'react-icons/bs';
import {
  AiOutlineMinusSquare,
  AiOutlinePlusSquare,
  AiOutlineFilter,
} from 'react-icons/ai';

const useStyles = makeStyles((theme) => ({
  header: {
    background: '#fff',
    marginTop: '15px',
    width: '100%',
  },
  title: {
    color: '##272727',
    fontWeight: 600,
  },
  selectTabs: {
    padding: '10px',
  },
  facultyInfoSection: {
    background: '#fff',
  },
  accordionMain: {
    background: 'transparent',
  },
  accordionTable: {
    background: '#fff',
  },
  refreshBtn: {
    float: 'right',
    marginTop: '6px',
    height: '34px !important',
    marginBottom: '8px',
    fontSize: '12px',
    background: '##272727 !important',
    color: '#fff',
    borderRadius: '5px',
  },
  searchFilter: {
    position: 'absolute',
    right: '10px',
    width: '300px',
  },
  courseList: {
    minHeight: '45px',
    background: '#fff',
    marginTop: '10px',
    width: '100%',
  },
  tableText: {
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '58%',
    transform: 'translate(-50%, -50%)',
  },
}));
export default function FacultyEnrollment(props) {
  const classes = useStyles();
  const userDetails = localStorage.getItem('userDetails');
  const [selectDepartmentOption, setDepartmentOption] = useState([]);
  const [selectProgramOption, setProgramOption] = useState([]);
  const [selectProgramPlanOption, setProgramPlanOption] = useState([]);
  const [selectTermOption, setTermOption] = useState([]);
  const [selectSectionOption, setSectionOption] = useState([]);
  const [facultyInfo, setFacultyInfo] = useState({});
  const [accordionCheck, setAccordionCheck] = useState(true);
  const [searchInput, setSearchInput] = React.useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [filterData, setFilterData] = useState([]);
  const [studentInfo, setStudentInfo] = useState({});
  const [searchString, setSearchString] = useState(null);
  const [showData, setShowData] = useState(false);
  const [facultyOption, setFacultyOption] = useState([]);
  const [term, setTerm] = useState('');
  const [section, setSection] = useState('');
  const [disabled, setDisabled] = useState(true);
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  // const [sectionList, setSectionList] = useState([]);
  const columns = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) => selectedCheckBoxItem(event, row, data)}
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Subject Name',
      accessor: 'courseName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject Code',
      accessor: 'courseId',
      disableGlobalFilter: false,
    },
    {
      Header: 'Section',
      accessor: 'section',
      disableGlobalFilter: false,
      Cell: ({ value, row }) => {
        const sectionList = [];
        value.map((item) => {
          sectionList.push({
            label: item.courseSectionId,
            value: item.id,
          });
        });
        return (
          <div className="faculty-section-div">
            <KenSelect
              optionalLabel={false}
              options={sectionList}
              value={value?.selectedSection}
              onChange={(e) => handleChangeSection(e, row, value)}
              placeholder="Select Section"
              required
            />
          </div>
        );
      },
    },
    {
      Header: 'Enrolled Faculty',
      accessor: 'enrolledFaculty',
      disableGlobalFilter: false,
      Cell: ({ value, row }) => {
        return (
          <div className="faculty-autocomplete-div">
            <Autocomplete
              multiple
              id="size-small-outlined"
              size="large"
              className="faculty-autocomplete"
              options={value}
              defaultValue={value.find((v) => v.label)}
              getOptionLabel={(option) => option.title}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="faculty-autocomplete-text"
                  placeholder="Enrolled Faculty"
                />
              )}
              required
            />
          </div>
        );
      },
    },
    {
      Header: 'Select Faculty',
      accessor: '',
      Cell: ({ value, row }) => {
        return (
          <div className="faculty-autocomplete-div">
            <Autocomplete
              multiple
              id="size-small-outlined"
              size="large"
              className="faculty-autocomplete"
              options={facultyOption}
              onChange={(event, option) =>
                handleSelectFaculty(event, option, row, data)
              }
              getOptionLabel={(option) => option.title}
              required
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="faculty-autocomplete-text"
                  placeholder="Select Faculty"
                />
              )}
            />
          </div>
        );
      },
      disableGlobalFilter: false,
    },
  ];
  const handleSelectFaculty = (event, option, row, data) => {
    if (option != null) {
      const tempData = data;
      let optionData = [];
      option.map((item) => {
        optionData.push(item.value);
      });
      tempData[row.index].faculty = optionData;
      setData(tempData);
    } else {
      const tempData = data;
      delete tempData[row.index].faculty;
      setData(tempData);
    }
  };
  const handleChangeDepartment = (e) => {
    setStudentInfo({ ...studentInfo, department: e.target.value });
    const ProgramOption = [];
    const dataS = Object.entries(
      filterData.AcdemicProgramsForEachDepartment
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    dataS[0][1].map((items) => {
      ProgramOption.push({
        label: items.AcademicProgramName,
        value: items.AcademicProgramId,
      });
    });
    setProgramOption(ProgramOption);
  };
  const handleChangeProgram = (e) => {
    setStudentInfo({ ...studentInfo, program: e.target.value });
    // For Program Plan
    const ProgramPlanOption = [];
    const dataS2 = Object.entries(
      filterData.ProgramPlanForEachAcedemicProgram
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    dataS2[0][1].map((items) => {
      ProgramPlanOption.push({
        label: items.ProgramPlanName,
        value: items.ProgramPlanId,
      });
    });
    setTermOption([]);
    setProgramPlanOption(ProgramPlanOption);
  };
  const handleChangeProgramPlan = (e) => {
    setTermOption([]);
    setStudentInfo({ ...studentInfo, programPlan: e.target.value });
    const TermOption = [];
    const dataS = Object.entries(filterData.TermForEachProgramPlan).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        TermOption.push({
          label: items.TermName,
          value: items.TermId,
        });
      });
      setTermOption(TermOption);
    }
  };
  const handleChangeTerm = (e) => {
    setTerm(e.target.value);
    setStudentInfo({ ...studentInfo, term: e.target.value });
    const SectionOption = [];
    const dataS = Object.entries(filterData.SectionsForEachTerm).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        SectionOption.push({
          label: items.SectionName,
          value: items.SectionName,
        });
      });
      console.log('SectionOption', SectionOption);
      setSectionOption(SectionOption);
    }
  };
  const handleChangeSection = (e, row, value) => {
    const tempData = data;
    tempData[row.index].selectedSection = e.target.value;
    setData(tempData);
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setLoading(false);
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const enrollFaculty = () => {
    setLoading(true);
    let newData = data.filter((item) => {
      if (item.checked && item.faculty != undefined) {
        return item;
      }
    });
    if (newData.length > 0) {
      let payload = [];
      newData.map((item) => {
        item?.faculty.map((item2) => {
          payload.push({
            facultyId: item2,
            courseOfferingId: item?.selectedSection,
          });
        });
      });
      console.log('payload', payload);
      postFacultyEnrollment(payload)
        .then((res) => {
          let successCheck = res.data.every((item) => item.status === true);
          if (successCheck) {
            handleSnackbarOpen('success', 'Faculty Enrolled.');
          } else {
            handleSnackbarOpen('info', 'Faculty has already been enrolled');
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          handleSnackbarOpen('error', 'Something went wrong');
        });
    } else {
      handleSnackbarOpen(
        'error',
        'Please select faculty for the selected subject'
      );
    }
  };
  const filterBtn = () => {};
  React.useEffect(() => {
    let querry = searchString != null ? `?name=${searchString}` : null;
    getFacultyList(querry)
      .then((res) => {
        console.log(res);
        const facultyOption = [];
        res?.map((item) => {
          facultyOption.push({
            title: item?.facultyName,
            value: item?.facultyId,
          });
        });
        setFacultyOption(facultyOption);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  React.useEffect(() => {
    setLoading(true);
    let data = `?term=${term}`;
    getCourseVersionData(data)
      .then((res) => {
        console.log(res);
        if (res.message) {
          setData([]);
        } else {
          let courseData = Object.entries(res).map((item) => {
            return item[1];
          });
          let newData = [];
          courseData[0].map((items) => {
            let enrolledFaculty = [];
            items.courseOffering[0]?.faculty.length > 0 &&
              items.courseOffering[0]?.faculty.map((item) => {
                enrolledFaculty.push({
                  title: item?.facultyName,
                  value: item?.facultyContactId,
                });
              });
            newData.push({
              courseName: items.courseName,
              courseId: items.courseId,
              section: items.courseOffering,
              enrolledFaculty: enrolledFaculty,
              items: items,
            });
          });
          setData(newData);
          setShowData(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [term]);

  React.useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    getDataForCourseEnrolment(instituteId).then((res) => {
      const DepartmentOption = [];
      res.DepartmentsList.map((item) => {
        DepartmentOption.push({
          label: item.DepartmentName,
          value: item.DepartmentId,
        });
      });
      setDepartmentOption(DepartmentOption);
      setFilterData(res);
      setLoading(false);
    });
  }, []);
  const selectedCheckBoxItem = (event, row, data) => {
    const tempData = data;
    tempData[row.index].checked = event.target.checked;
    setData(tempData);
  };

  return (
    <Grid container xs={12}>
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      {loading && <KenLoader />}
      <div position="static" elevation={0} className={classes.header}>
        <Toolbar style={{ minHeight: '45px' }}>
          <Typography className={classes.title}>Faculty Enrollment</Typography>
        </Toolbar>
      </div>
      <div className={classes.courseList}>
        <Grid container xs={12}>
          <Grid container xs={3} style={{ position: 'relative' }}>
            <Typography className={classes.tableText}>Course List</Typography>
          </Grid>
          <Grid container xs={9} className={classes.facultyInfoSection}>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Institute Department"
                optionalLabel={false}
                options={selectDepartmentOption}
                value={facultyInfo.department}
                defaultSearchValue={facultyInfo.department || ''}
                onChange={(e) => handleChangeDepartment(e)}
                placeholder="Institute Department"
                required
              />
            </Grid>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Academic Program"
                optionalLabel={false}
                options={selectProgramOption}
                value={facultyInfo.program}
                defaultSearchValue={facultyInfo.program || ''}
                onChange={(e) => handleChangeProgram(e)}
                placeholder="Academic Program"
                required
              />
            </Grid>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Program Plan"
                optionalLabel={false}
                options={selectProgramPlanOption}
                value={facultyInfo.programPlan}
                defaultSearchValue={facultyInfo.programPlan || ''}
                onChange={(e) => handleChangeProgramPlan(e)}
                placeholder="Program Plan"
                required
              />
            </Grid>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Term"
                optionalLabel={false}
                options={selectTermOption}
                value={facultyInfo.term}
                defaultSearchValue={facultyInfo.term || ''}
                onChange={(e) => handleChangeTerm(e)}
                placeholder="Term"
                required
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
      {showData ? (
        <Grid xs={12}>
          <div className="faculty-enroll-table" style={{ width: '100%' }}>
            <KenGrid
              columns={columns}
              data={data}
              pagination={{ disabled: true }}
              toolbarDisabled={true}
            />
          </div>
          <KenButton
            label="Enroll"
            onClick={() => enrollFaculty()}
            variant="primary"
            // disabled={disabled}
            className={classes.refreshBtn}
          />
        </Grid>
      ) : null}
    </Grid>
  );
}
